import { Loader2 } from 'lucide-react'
import { FC } from 'react'

const ModalLoader: FC = () => {
  return (
    <div className="flex h-full items-center justify-center">
      <Loader2 className="size-m animate-spin text-gray-400" />
    </div>
  )
}

export default ModalLoader
